<template>
  <div>
    <div v-if="loading">loading...</div>
    <div v-if="!loading" class="table-responsive">
      <table class="table table-sm text-nowrap">
        <tr>
          <th>ID</th>
          <th>仕事ID</th>
          <th>ユーザーID</th>
          <th>閲覧日時</th>
        </tr>
        <tr v-for="(jobView, index) in this.jobViews" :key="index">
          <td>{{ jobView.id }}</td>
          <td>{{ jobView.jobId }}</td>
          <td>{{ jobView.userId }}</td>
          <td>{{ jobView.browsedAt }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import master from '@/constants/MasterEnum'
import firebase from 'firebase'
import utils from '@/utils/Utils'

export default {
  name : "jobViewInfo",
  mixins: [
    utils,
    master
  ],
  data () {
    return {
      loading : false,
      db : firebase.firestore(),
      jobViews : [],
    }
  },
  props : {
    firstDate : {
      type : Date,
      required : true,
    },
    lastDate : {
      type : Date,
      required : true,
    }
  },
  created: function() {
    this.loading = true;
      this.db.collection("job_detail_view_histories")
      .orderBy('browsed_at', 'asc')
      .startAt(this.firstDate)
      .endAt(this.lastDate)
      .get()
      .then((query) => {
        query.forEach((doc) => {
          var data = doc.data();
          this.jobViews.push({
            id : doc.id,
            jobId : this.escapeNull(data.job_id),
            userId : this.escapeNull(data.user_id),
            browsedAt : this.formatDateTime((data.browsed_at).toDate()),
          });
        });
      })
      .then(() => {
        this.loading = false;
        this.$emit('bind-event' , this.jobViews , this.tsvFormat.jobViewInfo.fileName , this.tsvFormat.jobViewInfo.labels)
      });
  }

}
</script>
